module.exports = __webpack_public_path__ + "static/media/cbd-band.178512b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/cbd-band.mp4
// module id = IDTr
// module chunks = 1